import './VerificationStatus.css';
// Components
import IonicPageWrapper from '../../components/IonicPageWrapper/IonicPageWrapper';
// ICONs & SVGs
import verificationGif from '../../imgs/verification.gif'

function VerificationStatus() {
    return (
        <IonicPageWrapper hideHeader >
            <div id="verification_status">
                <section className='verification_status_cont' >
                    <img src={verificationGif} />
                    <p>Account sent to class teacher for verification</p>
                    <sub>If any issue please contact your class teacher</sub>
                </section>
            </div>
        </IonicPageWrapper>
    )
}

export default VerificationStatus